import { render, staticRenderFns } from "./SplitIcon.vue?vue&type=template&id=d416aa02&"
import script from "./SplitIcon.vue?vue&type=script&lang=js&"
export * from "./SplitIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports